'use client';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import Link from 'next/link';

import LoaderImage from '@/components/LoaderImage';
import { StoreContext } from '../Store';
import { IMedia } from '@/interfaces/homeBanner.interface';

export const DisplayBanner = ({ banner }: { banner: IMedia | null }) => {
  const t = useTranslations('home_banner');
  return (
    <>
      {banner?.mimeType.startsWith('video') ? (
        <video autoPlay loop muted className="h-screen w-full object-cover">
          <source src={banner?.s3url} type="video/mp4" />
          {t('home_banner_vdo')}
        </video>
      ) : (
        <img className="h-screen w-full object-cover" src={banner?.s3url} alt={banner?.s3url} />
      )}
    </>
  );
};

const HomeBanner = () => {
  const { featureStoryState, settingsState } = useContext(StoreContext);
  const [settings] = settingsState;
  const [featureStories] = featureStoryState;

  return (
    <>
      <div
        className={`grid ${settings?.headerBanner && settings?.headerBanner2 ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1'}`}
      >
        {settings?.headerBanner && (
          <div className="col-span-1">
            <Link href={settings?.headerBannerLink || ''}>
              <DisplayBanner banner={settings?.headerBanner} />
            </Link>
          </div>
        )}
        {settings?.headerBanner2 && (
          <div className="col-span-1">
            <Link href={settings?.headerBanner2Link || ''}>
              <DisplayBanner banner={settings?.headerBanner2} />
            </Link>
          </div>
        )}
      </div>

      <div className="grid grid-cols-2">
        {featureStories?.map((featureStory, index) => (
          <div
            key={`home_page_featured_story_${featureStory._id}_${index}`}
            className="group w-full cursor-pointer md:h-full [&:nth-last-child(1):nth-child(odd)]:col-span-2"
          >
            <Link href={`/stories/${featureStory?.slug}`}>
              <LoaderImage
                alt="bannercontentone"
                src={featureStory?.thumbnail?.s3url}
                className="w-full grayscale filter group-hover:grayscale-0 md:h-full"
              />
            </Link>
          </div>
        ))}
      </div>
    </>
  );
};

export default HomeBanner;
